import React from 'react';
import { Link } from 'react-router-dom';
import { Icon } from '../Icon';

export const generateFormButtons =
  ({
    submitLabel = 'Save',
    cancelPath,
    cancelLabel = 'Cancel',
    handleCancel,
    handleDelete,
    includeReset,
    addContentStart,
    addContentEnd,
    alwaysSubmittable = false,
  } = {}) =>
  props => (
    <>
      {addContentStart}
      <button
        type="submit"
        className="btn btn-primary"
        disabled={props.submitting || (!alwaysSubmittable && !props.dirty)}
        onClick={props.submit}
      >
        {props.submitting ? (
          <Icon name="circle-notch" spin />
        ) : (
          <Icon name="check" />
        )}
        <span>{submitLabel}</span>
      </button>
      {typeof handleCancel === 'function' ? (
        <button
          type="button"
          className="btn btn-link-primary"
          disabled={props.submitting}
          onClick={handleCancel(props.dirty)}
        >
          {cancelLabel}
        </button>
      ) : cancelPath ? (
        typeof cancelPath === 'function' ? (
          <button
            type="button"
            className="btn btn-link-primary"
            disabled={props.submitting}
            onClick={cancelPath}
          >
            {cancelLabel}
          </button>
        ) : (
          <Link className="btn btn-link-primary" to={cancelPath}>
            {cancelLabel}
          </Link>
        )
      ) : null}
      {includeReset && (
        <button
          type="button"
          className="btn btn-link-primary"
          disabled={!props.dirty || props.submitting}
          onClick={props.reset}
        >
          Reset
        </button>
      )}
      <div className="mx-auto" />
      {handleDelete && (
        <button
          type="button"
          className="btn btn-link-danger"
          disabled={props.submitting}
          onClick={handleDelete}
        >
          Delete
        </button>
      )}
      {addContentEnd}
    </>
  );

export const FormButtons = generateFormButtons({
  submitLabel: 'Save',
  cancelPath: null,
});
